import { bookingOutcomeWarning } from '../../shared/bookingOutcome'
import './bookingOutcomeWarning.css'

export function BookingOutcomeWarning({ state, payment }: { state: string; payment: string | null }) {
  const warning = bookingOutcomeWarning(state, payment)
  if (!warning) return null
  return <span className="booking-outcome-warning" role="status">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10.3 3.9a2 2 0 0 1 3.4 0l8 14a2 2 0 0 1-1.7 3H4a2 2 0 0 1-1.7-3Z" /><path d="M12 9v4m0 4h.01" /></svg>
    <span>{warning}</span>
  </span>
}
